// Helper function to save to session storage
const saveToStorage = (state) => {
  try {
    const dataToSave = {
      leadGenQuestions: state.leadGenQuestions,
      answers: state.answers,
      currentQuestionIndex: state.currentQuestionIndex,
      orgGuid: state.orgGuid,
      orgType: state.orgType,
      settings: state.settings,
      sac: state.sac
    }
    sessionStorage.setItem('leadGenFlow', JSON.stringify(dataToSave))
  } catch (error) {
    console.error('Failed to save to session storage:', error)
  }
}

export default {
  setAnswers (state, payload) {
    state.answers = payload
    saveToStorage(state)
  },
  setQuestionFlowData (state, payload) {
    const previewQuestion = payload?.previewQuestion || false
    const questions = payload?.form?.questions
    const availableQuestions = questions?.filter(question => question.enabled || question.required)

    state.leadGenQuestions = previewQuestion ? questions : availableQuestions
    state.totalSteps = previewQuestion ? questions?.length : availableQuestions?.length || 0
    state.propertyType = payload?.form?.type
    saveToStorage(state)
  },
  setOrgGuid (state, payload) {
    state.orgGuid = payload
    saveToStorage(state)
  },
  setOrgId (state, payload) {
    state.orgId = payload
  },
  setOrgType (state, payload) {
    state.orgType = payload
    saveToStorage(state)
  },
  setSettings (state, payload) {
    state.settings = payload
    saveToStorage(state)
  },
  setCurrentQuestionIndex (state, payload) {
    state.currentQuestionIndex = payload
    saveToStorage(state)
  },
  setFormSubmitted (state, payload) {
    state.formSubmitted = payload
  },
  setSac (state, payload) {
    state.sac = payload
    saveToStorage(state)
  },
  setPreviewForm (state, payload) {
    state.previewForm = payload
  },
  setPreviewQuestion (state, payload) {
    state.previewQuestion = payload
  },
  setShowLandingPage (state, payload) {
    state.showLandingPage = payload
  },
  clearSession (state) {
    const contactInfo = state.answers.contact_info || {}

    state.leadGenQuestions = []
    state.answers = { contact_info: contactInfo }
    state.currentQuestionIndex = 0

    // Clear session storage
    try {
      sessionStorage.removeItem('leadGenFlow')
    } catch (error) {
      console.error('Failed to clear session storage:', error)
    }
  },
  setPartnerSettings (state, payload) {
    state.settings.partnerImageUrl = payload.partnerImageUrl
    state.settings.partnerInitials = payload.partnerInitials
  },
  reinitializeServicerSettings (state) {
    state.settings.orgIcon = null
    state.settings.orgAppIcon = null
    state.settings.servicerImageUrl = null
    state.settings.servicerInitials = null
    state.settings.landingPageTitle = null
  },
  reinitializeOrgSettings (state) {
    state.settings.landingPageTitle = null
    state.settings.submissionPageBodyText = null
    state.settings.orgIcon = null
    state.settings.orgAppIcon = null
    state.settings.name = null
  },
  reinitializePartnerSettings (state) {
    state.settings.partnerImageUrl = null
    state.settings.partnerInitials = null
  }
}
